module.exports = __webpack_public_path__ + "static/img/sign-4.6c49d0dd.png";